import { render, staticRenderFns } from "./SchoolYearEdit.vue?vue&type=template&id=d3ade28c"
import script from "./SchoolYearEdit.vue?vue&type=script&lang=js"
export * from "./SchoolYearEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports